export default function MovementsTab() {
  return (
    <div style={{ padding: 24 }}>
      <h2>Движения склада</h2>
      <p>Журнал движений будет доступен после подключения API.</p>
    </div>
  );
}
